import { useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const SignaturePad = ({ open, onClose, onSave, title }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [dirty, setDirty] = useState(false);

  const init = (c) => {
    if (!c) return;
    canvasRef.current = c;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#111";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  };

  const pos = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    return [(e.clientX - r.left) * (c.width / r.width), (e.clientY - r.top) * (c.height / r.height)];
  };
  const down = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const [x, y] = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const [x, y] = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setDirty(true);
  };
  const up = () => { drawing.current = false; };
  const clear = () => {
    init(canvasRef.current);
    setDirty(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setDirty(false); onClose(); } }}>
      <DialogContent className="bg-white text-black rounded-none max-w-md" data-testid="signature-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-black tracking-tighter text-xl">{title || "SIGN HERE"}</DialogTitle>
        </DialogHeader>
        <canvas
          ref={init}
          width={560}
          height={280}
          data-testid="signature-canvas"
          className="border-2 border-black w-full touch-none bg-white cursor-crosshair"
          onPointerDown={down}
          onPointerMove={move}
          onPointerUp={up}
          onPointerLeave={up}
        />
        <div className="grid grid-cols-2 gap-2">
          <button data-testid="signature-clear-button" onClick={clear} className="border border-neutral-300 py-2.5 text-xs font-bold uppercase tracking-widest text-neutral-600">Clear</button>
          <button
            data-testid="signature-save-button"
            disabled={!dirty}
            onClick={() => { onSave(canvasRef.current.toDataURL("image/png")); setDirty(false); }}
            className="bg-black text-white py-2.5 text-xs font-bold uppercase tracking-widest disabled:opacity-40"
          >
            Save signature
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
